<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Všetky moje visačky"
      header="Visačky"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:5px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/visacky/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Visacky',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/visacky/visacka1.jpg','/static/images/visacky/visacka2.jpg'],
        title: "Visačky - 2,30 €",
        subtitle: "Visačky",
        details: "...visačky vytvorené technikou decoupage, prelakované.V sade sú 3 kusy.",
        size: "7 x 5,5 cm",
        material: "kartón, špagát",
        kind: "decoupage, lepenie",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Visacky.vue